(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const body = document.body;
    let drawer = document.getElementById('cart-drawer');
    const focusableSelector =
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
    const root = window.Shopify?.routes?.root || '/';
    const sectionHandle = 'cart-drawer';

    if (!drawer) return;

    let lastActiveElement = null;
    let isMutating = false;
    let adjustmentNoticeActive = false;

    const syncRefs = () => {
      drawer = document.getElementById('cart-drawer');
    };

    const getFocusable = () => Array.from(drawer.querySelectorAll(focusableSelector));

    const getOpeners = () => document.querySelectorAll('[data-cart-open]');

    const setDrawerState = (open) => {
      body.classList.toggle('cart-open', open);

      if (!drawer) return;

      drawer.setAttribute('aria-hidden', String(!open));
      getOpeners().forEach((opener) => opener.setAttribute('aria-expanded', String(open)));

      if (!open && lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    };

    const trapFocus = (event) => {
      if (event.key !== 'Tab') return;

      const focusable = getFocusable();
      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      const [first, last] = [focusable[0], focusable[focusable.length - 1]];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
        return;
      }

      if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const formatMoney = (amountCents, currency = 'USD') => {
      const value = Number(amountCents || 0) / 100;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      });

      return formatter.format(value);
    };

    const syncCartSummary = (cart) => {
      const subtotalNode = document.querySelector('[data-cart-subtotal]');
      if (subtotalNode && cart?.total_price != null) {
        subtotalNode.textContent = formatMoney(cart.total_price, cart.currency || 'USD');
      }

      const openerCount = typeof cart?.item_count === 'number' ? cart.item_count : null;
      if (openerCount != null) {
        getOpeners().forEach((opener) => {
          // preserve the <span> label so it stays hidden on mobile via CSS, instead of flattening to text
          const label = opener.querySelector('span');
          const labelText = label ? label.textContent : 'Cart';
          opener.replaceChildren();
          const labelNode = document.createElement('span');
          labelNode.textContent = labelText;
          opener.append(labelNode, ` (${openerCount})`);
        });
      }
    };

    const updateOpenersCount = async () => {
      try {
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });

        if (!response.ok) return;

        const cart = await response.json();
        syncCartSummary(cart);
      } catch (_error) {
        // Keep current drawer state if count refresh fails.
      }
    };

    const showCheckoutError = () => {
      document.querySelector('[data-cart-checkout-error]')?.removeAttribute('hidden');
    };

    const hideCheckoutError = () => {
      document.querySelector('[data-cart-checkout-error]')?.setAttribute('hidden', '');
    };

    // finds lines whose displayed quantity exceeds available stock, however they got there
    const collectInvalidQuantities = () => {
      const corrections = [];

      document.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
        const maxAttribute = input.getAttribute('data-max-quantity');
        const maxQuantity = maxAttribute !== null && maxAttribute !== '' ? Number.parseInt(maxAttribute, 10) : null;
        const quantity = Number.parseInt(input.value, 10) || 0;
        const lineId = input.getAttribute('data-line-id');

        if (lineId && Number.isFinite(maxQuantity) && quantity > maxQuantity) {
          corrections.push({ lineId, maxQuantity });
        }
      });

      return corrections;
    };

    // sequentially clamps every over-quantity line back down to available stock server-side
    const correctInvalidQuantities = async () => {
      const corrections = collectInvalidQuantities();
      if (!corrections.length) return false;

      console.log('[cart drawer] correcting quantities that exceed availability', corrections);
      adjustmentNoticeActive = true;
      showCheckoutError();

      for (const { lineId, maxQuantity } of corrections) {
        await mutateCartLine(lineId, maxQuantity);
      }

      return true;
    };

    const getLineImageSource = (line) => {
      const image = line.querySelector('[data-image-final]');
      if (!image) return null;

      return [image.dataset.src, image.dataset.srcset, image.alt].join('|');
    };

    const areLineDetailsEqual = (currentLine, nextLine) => {
      const normalize = (line) => {
        const clone = line.cloneNode(true);
        clone.querySelector('.cart-line__asset')?.remove();
        clone.querySelectorAll('button, input').forEach((control) => {
          control.removeAttribute('disabled');
          control.removeAttribute('aria-disabled');
          control.removeAttribute('aria-busy');
          control.classList.remove('is-loading');
        });
        return clone;
      };

      return normalize(currentLine).isEqualNode(normalize(nextLine));
    };

    const preserveUnchangedCartLines = (nextDrawer) => {
      const currentList = drawer?.querySelector('.cart-list');
      const nextList = nextDrawer.querySelector('.cart-list');
      if (!currentList || !nextList) return;

      const currentLines = new Map(
        Array.from(currentList.querySelectorAll('.cart-line'), (line) => [line.dataset.lineKey, line])
      );
      const nextLines = Array.from(nextList.querySelectorAll('.cart-line'));
      nextList.replaceChildren();

      nextLines.forEach((nextLine) => {
        const currentLine = currentLines.get(nextLine.dataset.lineKey);
        if (!currentLine) {
          nextList.append(nextLine);
          return;
        }

        const sameImage = getLineImageSource(currentLine) === getLineImageSource(nextLine);
        if (sameImage && areLineDetailsEqual(currentLine, nextLine)) {
          nextList.append(currentLine);
          return;
        }

        if (sameImage) {
          const currentAsset = currentLine.querySelector('.cart-line__asset');
          const nextAsset = nextLine.querySelector('.cart-line__asset');
          if (currentAsset && nextAsset) nextAsset.replaceWith(currentAsset);
        }

        nextList.append(nextLine);
      });
    };

    const renderDrawerMarkup = (sectionHtml) => {
      if (!sectionHtml) {
        throw new Error('Cart drawer section HTML missing in cart response.');
      }

      const wrapper = document.createElement('div');
      wrapper.innerHTML = sectionHtml;

      const nextDrawer = wrapper.querySelector('#cart-drawer');
      if (!nextDrawer || !drawer) {
        throw new Error('Drawer markup missing in section response.');
      }

      preserveUnchangedCartLines(nextDrawer);
      drawer.replaceWith(nextDrawer);
      syncRefs();
      window.initImagePlaceholders(drawer);

      document.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
        const syncStepperState = input.closest('[data-cart-quantity]')?.querySelector('[data-cart-quantity-input]');
        if (syncStepperState) {
          const stepper = syncStepperState.closest('[data-cart-quantity]');
          const buttons = stepper?.querySelectorAll('[data-cart-stepper-button]');
          const note = stepper?.parentElement?.querySelector('[data-cart-quantity-note]');
          const value = Number.parseInt(syncStepperState.value, 10) || 0;
          const maxAttribute = syncStepperState.getAttribute('data-max-quantity');
          const maxQuantity = maxAttribute !== null && maxAttribute !== '' ? Number.parseInt(maxAttribute, 10) : null;
          const limitReached = Number.isFinite(maxQuantity) && value >= maxQuantity;

          buttons?.forEach((button) => {
            const direction = button.getAttribute('data-direction');
            const disabled = (direction === 'decrease' && value <= 0) || (direction === 'increase' && limitReached);
            button.disabled = disabled;
            button.setAttribute('aria-disabled', String(disabled));
            button.classList.remove('is-loading');
            button.setAttribute('aria-busy', 'false');
          });

          if (note) {
            if (limitReached && Number.isFinite(maxQuantity)) {
              note.textContent = note.getAttribute('data-limit-message') || 'Maximum quantity reached for this item.';
              note.hidden = false;
            } else {
              note.hidden = true;
              note.textContent = '';
            }
          }
        }
      });

      if (body.classList.contains('cart-open')) {
        setDrawerState(true);
      }

      if (collectInvalidQuantities().length) {
        // defer past this render pass so mutateCartLine's isMutating guard has already reset
        setTimeout(() => correctInvalidQuantities(), 0);
      } else if (adjustmentNoticeActive) {
        // fresh markup always starts with the notice hidden, so re-show it until the user acknowledges it
        showCheckoutError();
      } else {
        hideCheckoutError();
      }
    };

    const refreshDrawerMarkup = async () => {
      const sectionsUrl = new URL(window.location.href);
      sectionsUrl.searchParams.set('sections', sectionHandle);

      const response = await fetch(sectionsUrl.toString(), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error('Failed to refresh cart drawer markup.');
      }

      renderDrawerMarkup((await response.json())[sectionHandle]);
    };

    const updateLineItem = async (lineId, quantity) => {
      const normalizedId = String(lineId || '').trim();
      const payload = {
        id: normalizedId,
        quantity,
        sections: sectionHandle,
        sections_url: window.location.pathname,
      };

      console.log('[cart drawer] change request payload', payload);

      if (!normalizedId) {
        throw new Error('Missing cart line id for quantity update.');
      }

      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload),
      });

      console.log('[cart drawer] change response status', response.status, response.statusText);

      if (!response.ok) {
        const errorText = await response.text();
        console.log('[cart drawer] change response body', errorText);
        throw new Error('Failed to update cart line item.');
      }

      return response.json();
    };

    const mutateCartLine = async (lineId, quantity) => {
      if (!lineId || isMutating) return;

      const lineNode = document.querySelector(`[data-line-id="${CSS.escape(lineId)}"]`);
      if (!lineNode && !document.querySelector(`[data-line-key="${CSS.escape(lineId)}"]`)) {
        console.log('[cart drawer] skipping stale line mutation', { lineId, quantity });
        return;
      }

      isMutating = true;
      console.log('[cart drawer] mutating cart line', { lineId, quantity });

      document.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
        input.disabled = true;
      });

      try {
        const cart = await updateLineItem(lineId, quantity);
        console.log('[cart drawer] cart response', cart);
        syncCartSummary(cart);
        renderDrawerMarkup(cart.sections?.[sectionHandle]);
      } catch (_error) {
        console.error('[cart drawer] mutation failed', _error);

        // the optimistic quantity was rejected server-side, restore the last known-good value
        document
          .querySelectorAll(`[data-cart-quantity-input][data-line-id="${CSS.escape(lineId)}"]`)
          .forEach((input) => {
            if (input.dataset.committedQuantity !== undefined) {
              input.value = input.dataset.committedQuantity;
            }
          });
      } finally {
        isMutating = false;
        document.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
          input.disabled = false;
        });
      }
    };

    const openDrawer = (event) => {
      if (event) event.preventDefault();

      lastActiveElement = document.activeElement;
      setDrawerState(true);

      const focusable = getFocusable();
      if (focusable.length) {
        focusable[0].focus();
      } else {
        drawer.focus();
      }
    };

    const closeDrawer = () => {
      setDrawerState(false);
      adjustmentNoticeActive = false;
      hideCheckoutError();
    };

    document.addEventListener('cart:quantity-change', (event) => {
      const { lineId, quantity } = event.detail || {};
      const normalizedId = String(lineId || '').trim();

      console.log('[cart drawer] quantity-change event', { lineId, normalizedId, quantity, detail: event.detail });

      if (!normalizedId || !Number.isFinite(quantity) || quantity < 0) return;

      mutateCartLine(normalizedId, quantity);
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      const openTrigger = target.closest('[data-cart-open]');

      if (openTrigger) {
        openDrawer(event);
        return;
      }

      if (target.closest('[data-cart-close]')) {
        closeDrawer();
        return;
      }

      const removeTrigger = target.closest('[data-cart-remove]');
      if (removeTrigger) {
        const lineId = String(
          removeTrigger.getAttribute('data-line-id') || removeTrigger.getAttribute('data-line-key') || ''
        ).trim();
        if (!lineId) return;
        mutateCartLine(lineId, 0);
      }
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      event.preventDefault();

      try {
        const formData = new FormData(form);
        formData.append('sections', sectionHandle);
        formData.append('sections_url', window.location.pathname);
        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });

        if (!addResponse.ok) throw new Error('Failed to add item to cart.');

        const addedItem = await addResponse.json();
        renderDrawerMarkup(addedItem.sections?.[sectionHandle]);
        await updateOpenersCount();
        openDrawer();
      } catch (_error) {
        // Keep the current drawer state when adding an item fails.
      }
    });

    document.addEventListener('submit', (event) => {
      const checkoutForm = event.target.closest('.cart-form');
      if (!checkoutForm || event.submitter?.name !== 'checkout') return;

      const invalidQuantities = collectInvalidQuantities();
      if (!invalidQuantities.length) return;

      // never let a quantity that exceeds available stock reach checkout
      event.preventDefault();
      console.log('[cart drawer] blocked checkout with invalid quantities', invalidQuantities);
      correctInvalidQuantities();
    });

    document.addEventListener('cart:refresh', async () => {
      try {
        await refreshDrawerMarkup();
        await updateOpenersCount();
      } catch (_error) {
        // Keep existing cart content if background refresh fails.
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!body.classList.contains('cart-open')) return;

      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }

      trapFocus(event);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-content"] && !Shopify.designMode) return;
  try {
    
  const openLinkedFaqDisclosure = () => {
    const query = new URLSearchParams(window.location.search);
    const anchorId = window.location.hash
      ? decodeURIComponent(window.location.hash.slice(1))
      : query.get('faq-anchor') || query.get('id');
    if (!anchorId) return;

    const anchor = document.getElementById(anchorId);
    const disclosure = anchor?.closest('[data-faq-disclosure]');
    if (disclosure) disclosure.open = true;
  };

  window.addEventListener('hashchange', openLinkedFaqDisclosure);

  window.initFaqDisclosures = (root = document) => {
    const mobileViewport = window.matchMedia('(max-width: 720px)');

    root.querySelectorAll('[data-faq-disclosure]:not([data-faq-initialized])').forEach((disclosure) => {
      const summary = disclosure.querySelector(':scope > summary');
      if (!summary) return;

      disclosure.setAttribute('data-faq-initialized', '');

      const syncDisclosure = () => {
        disclosure.open = !mobileViewport.matches;
        summary.tabIndex = mobileViewport.matches ? 0 : -1;
      };

      summary.addEventListener('click', (event) => {
        if (!mobileViewport.matches) event.preventDefault();
      });

      syncDisclosure();
      mobileViewport.addEventListener('change', syncDisclosure);
    });
  };

  window.initFaqDisclosures();
  openLinkedFaqDisclosure();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form"] && !Shopify.designMode) return;
  try {
    
  const initializeContactSubjects = (container = document) => {
    container.querySelectorAll('.contact-form__subjects').forEach((subjects) => {
      if (subjects.dataset.initialized === 'true') return;

      const options = subjects.querySelectorAll('.contact-form__subject');

      const syncSelected = () => {
        options.forEach((option) => {
          const input = option.querySelector('.contact-form__subject-input');
          const label = option.querySelector('.contact-form__subject-label');
          label.classList.toggle('bulleted', input.checked);
        });
      };

      options.forEach((option) => {
        const input = option.querySelector('.contact-form__subject-input');
        const label = option.querySelector('.contact-form__subject-label');

        option.addEventListener('mouseenter', () => label.classList.add('bulleted'));
        option.addEventListener('mouseleave', () => label.classList.toggle('bulleted', input.checked));
        input.addEventListener('change', syncSelected);
      });

      subjects.dataset.initialized = 'true';
      syncSelected();
    });
  };

  initializeContactSubjects();
  document.addEventListener('shopify:section:load', (event) => initializeContactSubjects(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const observeActiveCard = () => {
    const scroller = document.querySelector('.product-recommendations__grid');

    if (!scroller) return;

    const cards = Array.from(scroller.querySelectorAll('.product-card'));

    if (!cards.length) return;

    const setCardActive = (card, isActive) => {
      card.classList.toggle('product-card--active', isActive);
      const productInfo = card.querySelector('.product-info');

      if (productInfo) {
        productInfo.setAttribute('aria-hidden', String(!isActive));
      }
    };

    cards.forEach((card) => setCardActive(card, false));

    const updateActiveCard = () => {
      const scrollerRect = scroller.getBoundingClientRect();
      const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
      let activeCard = cards[0];
      let activeDistance = Infinity;

      cards.forEach((card) => {
        const cardRect = card.getBoundingClientRect();
        const cardScrollLeft = cardRect.left - scrollerRect.left + scroller.scrollLeft;
        const cardSnapLeft = Math.min(cardScrollLeft, maxScrollLeft);
        const distance = Math.abs(cardSnapLeft - scroller.scrollLeft);

        if (distance < activeDistance) {
          activeCard = card;
          activeDistance = distance;
        }
      });

      cards.forEach((card) => setCardActive(card, card === activeCard));
    };

    const scheduleActiveCardUpdate = () => {
      requestAnimationFrame(updateActiveCard);
    };

    scroller.addEventListener('scroll', scheduleActiveCardUpdate, { passive: true });
    window.addEventListener('resize', scheduleActiveCardUpdate);
    updateActiveCard();
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');

  if (productRecommendationsSection) {
    fetch(productRecommendationsSection.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          observeActiveCard();
          window.initImagePlaceholders?.(productRecommendationsSection);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const gallery = event.target.closest('.product__gallery');

    if (!gallery || gallery.scrollWidth <= gallery.clientWidth) return;

    const items = gallery.querySelectorAll('.product-image');
    const item = items[0];

    if (!item || items.length < 2) return;

    const step = item.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(gallery).columnGap) || 0;
    const currentIndex = Math.round(gallery.scrollLeft / (step + gap));
    const nextIndex = (currentIndex + 1) % items.length;

    gallery.scrollTo({ left: nextIndex * (step + gap), behavior: 'instant' });
  });

  (() => {
    const opener = document.querySelector('[data-size-guide-open]');
    const panel = document.querySelector('[data-size-guide-panel]');

    if (!opener || !panel) return;

    const closeTargets = panel.querySelectorAll('[data-size-guide-close]');

    const setSizeGuideState = (open) => {
      panel.setAttribute('aria-hidden', String(!open));
      opener.setAttribute('aria-expanded', String(open));
    };

    opener.addEventListener('click', () => setSizeGuideState(true));
    closeTargets.forEach((target) => target.addEventListener('click', () => setSizeGuideState(false)));

    document.addEventListener('click', (event) => {
      if (panel.getAttribute('aria-hidden') === 'true') return;
      if (event.target.closest('[data-size-guide-open]')) return;

      const image = panel.querySelector('.size-guide__image');
      const imageRect = image?.getBoundingClientRect();
      const clickedInsideImage =
        imageRect &&
        event.clientX >= imageRect.left &&
        event.clientX <= imageRect.right &&
        event.clientY >= imageRect.top &&
        event.clientY <= imageRect.bottom;

      if (!clickedInsideImage) setSizeGuideState(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') {
        setSizeGuideState(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
